var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.819,
    height: 41.755,
    viewBox: "0 0 30.819 41.755",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.5px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_8",
    "data-name": "Group 8",
    transform: "translate(.75 .75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape",
    d: "M0 38.7a1.556 1.556 0 0 0 1.551 1.551h26.216a1.556 1.556 0 0 0 1.552-1.551l-.078-30.168L20.709 0H1.551A1.556 1.556 0 0 0 0 1.551z",
    className: "prefix__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-2",
    d: "M0 0v6.825a1.8 1.8 0 0 0 1.784 1.784h6.825",
    className: "prefix__cls-1",
    transform: "translate(20.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-3",
    d: "M0 11.172a3.859 3.859 0 0 0 3.878 3.723 3.806 3.806 0 0 0 3.878-3.723 3.859 3.859 0 0 0-3.878-3.723A3.806 3.806 0 0 1 0 3.726 3.859 3.859 0 0 1 3.878 0a3.806 3.806 0 0 1 3.878 3.726",
    className: "prefix__cls-1",
    transform: "translate(10.859 12.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-4",
    d: "M.5 0v2.327",
    className: "prefix__cls-1",
    transform: "translate(14.625 27.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-5",
    d: "M.5 0v2.327",
    className: "prefix__cls-1",
    transform: "translate(14.625 10.083)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.b5ceda8c2cf7c7a409bb32fd9f3bfcf0.svg";
export { ForwardRef as ReactComponent };